var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconHeart = function SvgIconHeart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "m12 20.25-.49.872-.002-.001-.007-.004-.024-.014a15 15 0 0 1-.4-.237 30.609 30.609 0 0 1-4.434-3.295c-2.371-2.134-5.018-5.298-5.018-8.946A5.875 5.875 0 0 1 12 4.848a5.874 5.874 0 0 1 10.375 3.777c0 3.648-2.647 6.812-5.018 8.946a30.6 30.6 0 0 1-4.834 3.532l-.024.014-.007.004h-.002s-.001.002-.49-.871M9.321 5.205a3.875 3.875 0 0 0-5.696 3.42c0 2.727 2.04 5.376 4.356 7.46A28.6 28.6 0 0 0 12 19.086a28.591 28.591 0 0 0 4.018-3.001c2.316-2.084 4.357-4.733 4.357-7.46a3.875 3.875 0 0 0-7.452-1.49 1 1 0 0 1-1.846 0 3.88 3.88 0 0 0-1.756-1.93",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12 20.25.489.872c-.304.17-.675.17-.978 0z"
  }))));
};
export default SvgIconHeart;